var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-cards",
    {
      staticClass: "full-height bg-primary",
      attrs: { "data-test-id": "pxf-animation-card" },
    },
    [
      _c(
        "article",
        {
          staticClass:
            "p-1 p-md-2 text-center h-100 w-100 d-flex flex-column align-items-stretch justify-content-between background-img",
          style: _vm.isOrange
            ? "background-image: url(" + _vm.visual.src + ");"
            : null,
        },
        [
          _c("div", { staticClass: "mt-2 mt-md-3" }, [
            _c("div", { staticClass: "mobile-infos navads" }, [
              _vm.title
                ? _c("strong", {
                    staticClass: "h3 mb-0",
                    class: _vm.isOrange ? "text-primary2" : "text-white",
                    domProps: { innerHTML: _vm._s(_vm.title) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.subTitle
                ? _c("div", {
                    staticClass: "lead mb-0 text-white fw-bold",
                    domProps: { innerHTML: _vm._s(_vm.subTitle) },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infos-price navads" }, [
              _vm.text
                ? _c("p", {
                    staticClass: "mb-0 mt--1 text-white pt-2",
                    domProps: { innerHTML: _vm._s(_vm.text) },
                  })
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "px-1 infos-advantage navads" }),
          _vm._v(" "),
          _c("div", { staticClass: "infos-seller navads" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-1 d-webview-none" },
            [
              _vm.url !== undefined && _vm.urlAccessWording !== undefined
                ? _c("ob1-boutons", {
                    staticClass: "pb-1 mx-auto",
                    attrs: {
                      id: "tile-button",
                      "is-primary": true,
                      "is-button": false,
                      "is-inverse": _vm.isOrange,
                      label: _vm.urlAccessWording,
                      href: _vm.url,
                      target: "_blank",
                      "data-oevent-category":
                        "profitez_du_paiement_en_12_24_36_48_des_200_euros_d_achat",
                      "data-oevent-action": "en_savoir_plus",
                      "data-oevent-label": _vm.url,
                      "aria-label":
                        _vm.urlAccessWording + " sur le financement sur mesure",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }